import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { Box, Stack, useTheme } from "@mui/material";
import AuthSlider from "../AuthSlider";
import { useAppSelector } from "../../store/hooks";
import { selectIsLoggedIn } from "../../features/user/user.selector";
import { syncExtensionAuth } from "../../utils/extension";
import { useEffect } from "react";

export const AuthWrapper = () => {
  const theme = useTheme();
  const location = useLocation();
  const currentPath = location.pathname;
  const [searchParams] = useSearchParams();
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const fromExtension = searchParams.get("from") === "extension";

  useEffect(() => {
    if (fromExtension && currentPath === "/login" && isLoggedIn) {
      syncExtensionAuth(searchParams.get("from") === "extension");
    }
  }, []);

  if (isLoggedIn) {
    if (fromExtension && currentPath === "/signup") {
      return <Navigate to="/extension-signup-onboarding" />;
    }

    if (currentPath !== "/email-verify") {
      return <Navigate to="/product-analyzer" />;
    }
  }

  return (
    <Stack
      component="main"
      flexDirection="row"
      minHeight="100vh"
      sx={{
        [theme.breakpoints.down("md")]: {
          flexDirection: "column",
        },
      }}
    >
      <Box
        width="40%"
        sx={{
          [theme.breakpoints.down("md")]: {
            width: "100%",
          },
        }}
      >
        <AuthSlider />
      </Box>
      <Box
        width="60%"
        maxHeight="100vh"
        overflow="scroll"
        px={3}
        py={10}
        sx={{
          [theme.breakpoints.down("md")]: {
            width: "100%",
            maxHeight: "initial",
            order: -1,
          },
        }}
      >
        <Outlet />
      </Box>
    </Stack>
  );
};

export default AuthWrapper;
